import React, { Component } from "react";
import {
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import { SERVER_URL } from "../constants/variables";
import { getAuthHeaders, getEntityId, getUserRoleId, isSuperAdmin } from "../utils/api";
import Sidebar from "./Sidebar";
import toast from "react-hot-toast";
import { IoCreateOutline, IoTrashOutline, IoSearchOutline } from "react-icons/io5";
import "./TabsComponent.css";

class TabsComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      tabs: [],
      roles: [],
      idRoleMap: {},
      addModalOpen: false,
      editModalOpen: false,
      editingTabId: null,
      editingTabName: "",
      editingTabRoles: [],
      tabName: "",
      dashboardNumber: "",
      accessRoles: [],
      roleTabs: [],
      superAdminId: "",
      isOpen: false,
      tabsSearch: "",
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({ isOpen: !this.state.isOpen });
  }

  getTabsByRole = (roleId) => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    const authHeaders = getAuthHeaders();
    if (authHeaders.Authorization) myHeaders.append("Authorization", authHeaders.Authorization);

    var raw = JSON.stringify({
      role: roleId,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(SERVER_URL + "/tabs/getTabsByRole", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        this.setState({ roleTabs: result.tabs || [] });
      })
      .catch(() => {});
  };

  toggleAddModal = () => {
    this.setState({
      tabName: "",
      dashboardNumber: "",
      accessRoles: this.state.superAdminId ? [this.state.superAdminId] : [],
      addModalOpen: !this.state.addModalOpen,
    });
  };

  toggleEditModal = (tab = null) => {
    if (!tab) {
      this.setState({ editModalOpen: false, editingTabId: null, editingTabName: "", editingTabRoles: [] });
      return;
    }
    const tabId = getEntityId(tab);
    const roles = (tab.accessRoles || []).map((r) => getEntityId(r) ?? r?.id ?? r?._id).filter(Boolean);
    this.setState({
      editModalOpen: true,
      editingTabId: tabId,
      editingTabName: tab.name || "",
      editingTabRoles: roles,
    });
  };

  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  onAddTabSubmit = () => {
    var name = this.state.tabName;
    var dashboardNumber = this.state.dashboardNumber;
    var accessRoles = this.state.accessRoles;
    if (name === "" || dashboardNumber === "" || accessRoles.length === 0) {
      toast("Enter all fields");
    } else {
      toast.loading("Adding tab", {
        duration: 2000,
      });
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      const authHeaders = getAuthHeaders();
      if (authHeaders.Authorization) myHeaders.append("Authorization", authHeaders.Authorization);

      var raw = JSON.stringify({
        name: name,
        dashboardNumber: parseInt(dashboardNumber),
        roles: accessRoles,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch(SERVER_URL + "/tabs/addTab", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          toast.success("Tab added successfully");
          this.getTabs();
          this.getRoles();
          this.toggleAddModal();
        })
        .catch(() => {});
    }
  };

  getRoles = () => {
    fetch(SERVER_URL + "/roles/getRoles", { method: "GET", headers: getAuthHeaders(), redirect: "follow" })
      .then((res) => res.json())
      .then((result) => {
        if (result.success && result.roles) {
          const map = {};
          result.roles.forEach((item) => {
            map[getEntityId(item)] = item.name;
          });
          const superAdminEntry = result.roles.find((r) => (r.name || "").toUpperCase() === "SUPER_ADMIN");
          const superAdminId = superAdminEntry ? getEntityId(superAdminEntry) : "";
          this.setState({
            roles: result.roles,
            idRoleMap: map,
            superAdminId,
          });
          if (!isSuperAdmin(this.state.user, map)) {
            window.location = "/login";
          }
        }
      })
      .catch(() => {});
  };

  getTabs = () => {
    var requestOptions = {
      method: "GET",
      headers: getAuthHeaders(),
      redirect: "follow",
    };

    fetch(SERVER_URL + "/tabs/getTabs", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          this.setState({ tabs: result.tabs });
        }
      })
      .catch(() => {});
  };

  onSelectRoleRemove = (id) => {
    var accessRoles = this.state.accessRoles;
    var arr = accessRoles.filter(function (item) {
      return item !== id;
    });
    this.setState({
      accessRoles: arr,
    });
  };

  onSelectRoleChange = (e) => {
    const value = e.target.value;
    if (!value) return;
    const accessRoles = [...this.state.accessRoles];
    if (accessRoles.indexOf(value) === -1) {
      accessRoles.push(value);
      this.setState({ accessRoles });
    }
    e.target.value = "";
  };

  onEditRoleAdd = (e) => {
    const value = e.target.value;
    if (!value) return;
    const editingTabRoles = [...this.state.editingTabRoles];
    const id = typeof value === "number" ? value : parseInt(value, 10);
    if (!isNaN(id) && editingTabRoles.indexOf(id) === -1) editingTabRoles.push(id);
    else if (editingTabRoles.indexOf(value) === -1) editingTabRoles.push(value);
    this.setState({ editingTabRoles });
    e.target.value = "";
  };

  onEditRoleRemove = (id) => {
    this.setState({
      editingTabRoles: this.state.editingTabRoles.filter((r) => r !== id && String(r) !== String(id)),
    });
  };

  onUpdateTabSubmit = () => {
    const { editingTabId, editingTabName, editingTabRoles } = this.state;
    if (!editingTabId || !editingTabName?.trim()) {
      toast.error("Enter tab name");
      return;
    }
    // Normalize role ids to integers (backend may reject string ids)
    const roleIds = (editingTabRoles || [])
      .map((r) => (typeof r === "number" ? r : parseInt(r, 10)))
      .filter((n) => !isNaN(n) && n > 0);
    toast.loading("Updating tab...", { duration: 2000 });
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("tab", String(editingTabId));
    myHeaders.append("name", editingTabName.trim());
    const authHeaders = getAuthHeaders();
    if (authHeaders.Authorization) myHeaders.append("Authorization", authHeaders.Authorization);

    fetch(SERVER_URL + "/tabs/updateTab", {
      method: "PUT",
      headers: myHeaders,
      body: JSON.stringify({ roles: roleIds }),
      redirect: "follow",
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          toast.success("Tab updated successfully");
          this.getTabs();
          this.toggleEditModal();
        } else {
          toast.error(result.error || "Failed to update tab");
        }
      })
      .catch(() => {
        toast.error("Failed to update tab");
      });
  };

  componentDidMount() {
    if (localStorage.getItem("user") != null) {
      var user = localStorage.getItem("user");
      this.setState({
        user: JSON.parse(user),
      });
      this.getTabs();
      this.getRoles();
      this.getTabsByRole(getUserRoleId(JSON.parse(user)));

      // if (user.role === "SUPER_ADMIN") {
      //   this.setState({
      //     user: user,
      //   });
      // } else {
      //   window.location = "/login";
      // }
    }
  }

  getFilteredTabs = () => {
    const { tabs, tabsSearch } = this.state;
    if (!tabsSearch.trim()) return tabs;
    const q = tabsSearch.trim().toLowerCase();
    return tabs.filter((tab) => {
      const name = (tab.name || "").toLowerCase();
      const id = String(getEntityId(tab) ?? "").toLowerCase();
      return name.includes(q) || id.includes(q);
    });
  };

  render() {
    const filteredTabs = this.getFilteredTabs();
    return (
      <div className="app-layout">
        <Sidebar
          tabs={this.state.roleTabs}
          user={this.state.user}
          idRoleMap={this.state.idRoleMap}
        />
        <div className="main-content-wrapper">
          <div className="tabs-page-content">
            <div className="tabs-page-inner">
              <header className="tabs-page-header">
                <div className="tabs-page-header-text">
                  <h1 className="tabs-page-title">Dashboard Management</h1>
                  <p className="tabs-page-subtitle">Manage tabs and role access for dashboards</p>
                </div>
                <button type="button" className="tabs-btn tabs-btn-primary" onClick={this.toggleAddModal}>
                  <IoCreateOutline size={20} />
                  Add Tab
                </button>
              </header>

              {this.state.tabs.length > 0 && (
                <div className="tabs-search-wrap">
                  <IoSearchOutline className="tabs-search-icon" size={20} />
                  <input
                    type="text"
                    className="tabs-search-input"
                    placeholder="Search by tab name or ID…"
                    value={this.state.tabsSearch}
                    onChange={(e) => this.setState({ tabsSearch: e.target.value })}
                    aria-label="Search tabs"
                  />
                </div>
              )}

              <section className="tabs-card">
                <div className="tabs-table-wrap">
                  {this.state.tabs.length === 0 ? (
                    <div className="tabs-empty">
                      <div className="tabs-empty-icon">
                        <IoCreateOutline size={48} />
                      </div>
                      <p className="tabs-empty-title">No tabs yet</p>
                      <p className="tabs-empty-desc">Add a tab to control which roles can see each dashboard.</p>
                      <button type="button" className="tabs-btn tabs-btn-primary" onClick={this.toggleAddModal}>
                        Add your first tab
                      </button>
                    </div>
                  ) : filteredTabs.length === 0 ? (
                    <div className="tabs-empty tabs-empty-search">
                      <p className="tabs-empty-title">No matching tabs</p>
                      <p className="tabs-empty-desc">Try a different search term.</p>
                    </div>
                  ) : (
                    <table className="tabs-table">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Tab name</th>
                          <th className="tabs-table-th-actions">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredTabs.map((tab) => {
                          const tabId = getEntityId(tab);
                          return (
                            <tr key={tabId}>
                              <td className="tabs-table-id">{tabId}</td>
                              <td className="tabs-table-name">{tab.name}</td>
                              <td className="tabs-table-actions">
                                <button
                                  type="button"
                                  className="tabs-icon-btn tabs-icon-btn-edit"
                                  onClick={() => this.toggleEditModal(tab)}
                                  title="Edit tab"
                                >
                                  <IoCreateOutline size={18} />
                                  Edit
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  )}
                </div>
              </section>
            </div>
          </div>
        </div>

        {/* Add Tab Modal */}
        <Modal isOpen={this.state.addModalOpen} toggle={this.toggleAddModal} className="tabs-modal" contentClassName="tabs-modal-content">
          <ModalHeader toggle={this.toggleAddModal} className="tabs-modal-header">Add new tab</ModalHeader>
          <ModalBody className="tabs-modal-body">
            <Form className="tabs-form">
              <FormGroup className="tabs-form-group">
                <Label for="tabName" className="tabs-label">Tab name</Label>
                <Input
                  type="text"
                  id="tabName"
                  name="tabName"
                  placeholder="e.g. Sales Overview"
                  className="tabs-input"
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup className="tabs-form-group">
                <Label for="dashboardNumber" className="tabs-label">Dashboard number</Label>
                <Input
                  type="text"
                  id="dashboardNumber"
                  name="dashboardNumber"
                  placeholder="e.g. 33"
                  className="tabs-input"
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup className="tabs-form-group">
                <Label for="exampleSelect" className="tabs-label">Who can access this tab</Label>
                <Input
                  onChange={this.onSelectRoleChange}
                  id="exampleSelect"
                  name="select"
                  type="select"
                  className="tabs-select"
                >
                  <option value="">Select a role…</option>
                  {this.state.roles &&
                    this.state.roles.map((role) => (
                      <option key={getEntityId(role)} value={getEntityId(role)}>
                        {role.name}
                      </option>
                    ))}
                </Input>
              </FormGroup>
              {this.state.accessRoles && this.state.accessRoles.length > 0 && (
                <div className="tabs-chips-wrap">
                  <span className="tabs-label">Selected roles</span>
                  <div className="tabs-chips">
                    {this.state.accessRoles.map((roleId) => (
                      <span key={roleId} className="tabs-chip">
                        {this.state.idRoleMap[roleId] || roleId}
                        <button type="button" className="tabs-chip-remove" onClick={() => this.onSelectRoleRemove(roleId)} aria-label="Remove">
                          <IoTrashOutline size={14} />
                        </button>
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </Form>
          </ModalBody>
          <ModalFooter className="tabs-modal-footer">
            <button type="button" className="tabs-btn tabs-btn-ghost" onClick={this.toggleAddModal}>
              Cancel
            </button>
            <button type="button" className="tabs-btn tabs-btn-primary" onClick={this.onAddTabSubmit}>
              Add tab
            </button>
          </ModalFooter>
        </Modal>

        {/* Edit Tab Modal */}
        <Modal isOpen={this.state.editModalOpen} toggle={() => this.toggleEditModal()} className="tabs-modal" contentClassName="tabs-modal-content">
          <ModalHeader toggle={() => this.toggleEditModal()} className="tabs-modal-header">Edit tab</ModalHeader>
          <ModalBody className="tabs-modal-body">
            <Form className="tabs-form">
              <FormGroup className="tabs-form-group">
                <Label for="editingTabName" className="tabs-label">Tab name</Label>
                <Input
                  type="text"
                  id="editingTabName"
                  name="editingTabName"
                  placeholder="Tab name"
                  className="tabs-input"
                  value={this.state.editingTabName}
                  onChange={this.handleInputChange}
                />
              </FormGroup>
              <FormGroup className="tabs-form-group">
                <Label className="tabs-label">Access roles</Label>
                <Input type="select" className="tabs-select" onChange={this.onEditRoleAdd}>
                  <option value="">Add a role…</option>
                  {this.state.roles &&
                    this.state.roles.map((role) => (
                      <option key={getEntityId(role)} value={getEntityId(role)}>
                        {role.name}
                      </option>
                    ))}
                </Input>
              </FormGroup>
              {this.state.editingTabRoles && this.state.editingTabRoles.length > 0 && (
                <div className="tabs-chips-wrap">
                  <div className="tabs-chips">
                    {this.state.editingTabRoles.map((roleId) => (
                      <span key={roleId} className="tabs-chip">
                        {this.state.idRoleMap[roleId] || roleId}
                        <button type="button" className="tabs-chip-remove" onClick={() => this.onEditRoleRemove(roleId)} aria-label="Remove">
                          <IoTrashOutline size={14} />
                        </button>
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </Form>
          </ModalBody>
          <ModalFooter className="tabs-modal-footer">
            <button type="button" className="tabs-btn tabs-btn-ghost" onClick={() => this.toggleEditModal()}>
              Cancel
            </button>
            <button type="button" className="tabs-btn tabs-btn-primary" onClick={this.onUpdateTabSubmit}>
              Save changes
            </button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

export default TabsComponent;
